import React from "react";
import { Link } from "@quintype/components";

import StoryCard10 from "../../molecules/story-card10";
import CollectionName from "../../molecules/collection-name";
import PartialCarousel from "../../atoms/carousel-partial";
import Headline from "../../atoms/headline";
import CardImage from "../../atoms/cardimage";
import StoryDate from "../../atoms/story-date";
import Separator from "../../atoms/separator";
import SecVideoSelector from "../../molecules/secvideo-selector";

import "./video-slider.m.css";

const DesktopVideoSlider = ({ allStories, collection, selectItem, VideosCollections }) => {
  const firstStory = allStories.slice(0, 1)[0];
  const stories = allStories.slice(1, 7);

  return (
    <div styleName="desktop-video-slider">
      <CollectionName collection={collection} isSeeMore={false} />
      <SecVideoSelector selectItem={selectItem} VideosCollections={VideosCollections} />
      <Link href={`/${firstStory.slug}`}>
        <div styleName="first-card" className="hide-mobile">
          <CardImage
            story={firstStory && firstStory}
            aspectRatio={[16, 9]}
            imageType="image16x9"
            widths={[400, 1300]}
            sizes="(max-width: 1024px) 100vw, 100vw"
            showVideoIcon={true}
          />
          <div styleName="card-content">
            <div styleName="text-content">
              <Headline text={firstStory?.headline} headerType={3} headerLevel={1} story={firstStory} />
              <StoryDate story={firstStory} />
            </div>
          </div>
        </div>
      </Link>
      <div styleName="border-wrapper">
        <div styleName="wrapper">
          <PartialCarousel length={stories.length} showBullets showArrows>
            {stories.map((item, index) => (
              <StoryCard10 story={item} key={index} />
            ))}
          </PartialCarousel>
        </div>
      </div>
      <div className="hide-mobile">
        <Separator />
      </div>
    </div>
  );
};

export default DesktopVideoSlider;
